module.exports = __webpack_public_path__ + "befc22d07901a34d9a901d320db6ea6b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/calendula.jpg
 ** module id = 195
 ** module chunks = 0
 **/